import React from "react";
import PropTypes from "prop-types";
import { Table as SemanticTable } from "semantic-ui-react";
import { Table } from "dyl-components";
import SelectAllCheckbox from "shared/SelectAllCheckbox";
import {
    KEY_CATEGORY_NAME,
    KEY_CREATED_BY,
    KEY_DESCRIPTION,
    KEY_ACTIONS,
    KEY_TAGGED_CALLS,
} from "../contants";
import { useSelector } from "react-redux";

const Header = ({ isColumnHidden }) => {
    const { listOfTagCategories } = useSelector(
        (state) => state?.tag_categories
    );
    return (
        <Table.Row>
            <SemanticTable.HeaderCell width={1}>
                <SelectAllCheckbox
                    count={listOfTagCategories?.length}
                    data={listOfTagCategories}
                    type={"tags"}
                    idProperty={"id"}
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell />
            {!isColumnHidden(KEY_CATEGORY_NAME) && (
                <SemanticTable.HeaderCell
                    className="TagsTable__MediumFixedWidth"
                    width={3}
                >
                    Category Name
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_DESCRIPTION) && (
                <SemanticTable.HeaderCell
                    width={5}
                    className="TagsTable__MediumFixedWidth"
                >
                    Description
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_CREATED_BY) && (
                <SemanticTable.HeaderCell>Created By</SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_TAGGED_CALLS) && (
                <SemanticTable.HeaderCell>
                    Tagged Calls
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_ACTIONS) && (
                <SemanticTable.HeaderCell className="TagsTable__SmallFixedWidth">
                    Actions
                </SemanticTable.HeaderCell>
            )}
        </Table.Row>
    );
};

Header.propTypes = {
    isColumnHidden: PropTypes.func.isRequired,
};

export default Header;
